import {
  SORTING_SEARCH_RESULT_API,
  PRODUCTS_FETCH,
  PRODUCTS_FETCH_POPULAR,
  PRODUCTS_FETCH_RELATED,
  PRODUCT_DETAIL_FETCH,
  PROMISE_PENDING,
  PROMISE_REJECTED,
  PROMISE_FULFILLED,
  CART_ADD,
  PRODUCT_SEARCH_TO_KA_API,
  SORTING_SEARCH_RESULT,
  FILTERING_SEARCH_RESULT,
  CLEAR_BEFORE_FILTERING,
  FILTERING_HOMESCREEN,
  BROWSE_ALL_PRODUCT,
  BROWSE_ALL_POPULAR_SEARCH,
  GET_SIZE_BASE_PRODUCT_ID,
  UPDATE_ACTIVE_PRODUCT,
  SEARCH_RESULT_LOAD_MORE,
  MODAL_SEARCH_TOGGLE,
  FILTERING_FROM_API,
  GET_COLLECTION_VARIANTS,
  GET_ADDITIONAL_PRODUCT,
  EDITORS_CHOICE_PRODUCT,
  RECOMMENDED_PRODUCT,
  RECOMMENDED_PRODUCT_FULFILLED,
  RECOMMENDED_PRODUCT_PENDING,
  RECOMMENDED_PRODUCT_ERROR,
  UPCOMING_PRODUCT,
  SEARCH_OPEN,
  GET_MOST_SEARCH_RESULTS,
  FETCHING_MOST_SEARCH_RESULTS,
  MOST_SEARCH_RESULTS_ERROR,
  PRODUCT_SEARCH_PENDING_TOGGLE,
  ALL_HANDBAG_CONDITION_PENDING,
  ALL_HANDBAG_CONDITION_FULFILLED,
  ALL_HANDBAG_CONDITION_REJECTED,
  USER_RECENT_SEARCH,
  FECTH_SHOES_SALE_HISTORY_DATA,
  SEARCH_STATE,
  GET_TRENDING_PRODUCT,
  GET_TOP_SELLING_PRODUCT,
  GET_CONCIERGE,
  GET_COLLECTION_BY_SLUG,
  GET_COLLECTION_PRODUCT_LIST,
  SECTION_DETAILS,
  CLICK_MENU_NAVBAR,
  FETCH_COLLECTION_PRODUCT_LIST,
  COLLECTION_HOMEPAGE,
  GET_ALL_COLLECTION_BY_SLUG
} from '../constants/';

import _ from "lodash";
import { formatCurrency } from "../utils";
import AWS from "aws-sdk";

const initialCart = {
  cart: {
    product: {},
    user_sell: {},
    review: false,
  },
};
const initialState = {
  products: {
    data: [],
    isFetch: false,
    error: null,
    isProductFilter: false,
  },
  collection_variants: {
    data: [],
    isFetch: false,
    error: null,
  },
  isSearchResultPending: false,
  isFiltering: false,
  stillPending: false,
  hasExecute: false,
  caseSorting: 'most_popular',
  modalSearchOpen: false,
  dataRecommended: {
    data: [],
    isFetch: false,
    error: false,
  },
  searchResult: [],
  searchDrawer: [],
  status_code_filter: 0,
  message_filter: "",
  searchResultTmp: [],
  totalFilter: 0,
  concierge: {
    data: [],
    isFetch: false,
    error: null,
  },
  searchKeyword: "",
  redirectSearch: true,
  errorMessageSearch: "",
  productsInStock: [],
  productDetails: {},
  handbagCondition: {},
  productPopulars: {},
  brandsResult: [],
  pagination: null,
  upcomingProduct: {
    data: [],
    error: null,
    isFetch: false,
  },
  isSearchOpen: false,
  productCategories: {
    isFetch: false,
    categories: null,
    error: null,
  },
  recentSearch: {
    data: [],
    isFetching: false,
    error: null,
  },
  saleHistory: {
    data: [],
    isFetching: false,
    error: null,
  },
  trending: {
    data: [],
    isFetching: false,
    error: null,
    pagination: null,
  },
  topSelling: {
    data: [],
    isFetching: false,
    error: null,
    pagination: null,
  },
  collection: {
    isFetching: false,
    error: null,
    id: null,
    slug: null,
    collectionType: "product_variants",
    sort_by: "",
    products: {
      data: [],
      isFetching: false,
      status_code: null,
      hasMoreData: null,
    },
    imagePortrait: null,
    imageLandscape: null,
    status_code: null,
    all_category_banner: {
      imagePortrait: null,
      imageLandscape: null,
    }
  },
  dataSection: {
    data: {},
    error: null,
  },
  isClickMenu: false,
  ...initialCart
}

const onError = (err) => {
  return err.response !== null && err.response !== undefined
    ? { ...err.response.data }
    : {
      error: {
        message: "I got something undefined errors",
        status_code: 500,
      },
    };
};



const onGetMostSearchResults = (lastState, action, keyword) => {
  const { data, message, status_code } = action;
  return {
    ...lastState,
    searchKeyword: keyword,
    searchDrawer: data.data,
    errorMessageSearch: message,
    productCategories: {
      ...lastState.productCategories,
      categories: data.product_categories,
      status_code,
      message,
      isFetch: false,
      error: null,
    },
  };
};

const onFetchingMostSearchResult = (lastState, payload) => {
  return {
    ...lastState,
    productCategories: {
      ...lastState.productCategories,
      isFetch: payload.status,
    },
  };
};

const handleSearching = (state, payload, keyword, pagination, status_action, sort_by) => {
  if (payload.error === null || payload.error) {
    return { ...initialState };
  } else if (payload["response"] === undefined) {
    let obj = {};
    const counterBrands =
      payload.length > 0 &&
      payload.filter((item) => {
        if (item.product.brand === null) return false;
        if (obj[item.product.brand.name]) return false;
        obj[item.product.brand.name] = true;
        return true;
      });
    let finalBrand = [];
    let checkBrand =
      counterBrands.length > 0 &&
      counterBrands.map((item) => {
        finalBrand.push({
          id: item.product.brand.id,
          name: item.product.brand.name,
        });
      });
    // -- need refactor --
    let inStock = [];
    let outOfStock = [];
    let findStock =
      payload.length > 0 &&
      payload.map((item, index) => {
        if (item.latest_price) {
          outOfStock.push(item);
        } else {
          inStock.push(item);
        }
      });
    let finalSort = inStock.concat(outOfStock);
    const newData = _.uniqBy([...state.searchResult, ...finalSort], "id");

    return {
      ...state,
      // searchResult: status_action === 'LOAD_MORE' ? [ ...state.searchResult, ...finalSort ] : finalSort,
      searchResult: status_action === "LOAD_MORE" ? newData : finalSort,
      searchKeyword: keyword,
      errorMessageSearch: "Sneaker ditemukan",
      redirectSearch: true,
      isFiltering: false,
      isSearchResultPending: false,
      brandsResult: finalBrand,
      pagination,
      stillPending: false,
      caseSorting: sort_by
    }
  } else if (payload.response.status === 404) {
    return {
      ...state,
      searchResult: [],
      searchKeyword: keyword,
      errorMessageSearch: "Not Found",
      redirectSearch: true,
      isSearchResultPending: false,
      isFiltering: false,
      pagination: null,
      stillPending: false,
    };
  } else if (keyword === "") {
    return {
      ...state,
      searchResult: [],
      redirectSearch: true,
      errorMessageSearch: "",
      isFiltering: false,
      isSearchResultPending: false,
      stillPending: false,
      caseSorting: sort_by
    }
  } else {
    return { ...initialState };
  }
};
const handleSearchingModal = (state, payload, keyword, pagination, status_action, sort_by) => {
  if (payload.error === null || payload.error) {
    return { ...initialState };
  } else if (payload["response"] === undefined) {
    let obj = {};
    const counterBrands =
      payload.length > 0 &&
      payload.filter((item) => {
        if (item.product.brand === null) return false;
        if (obj[item.product.brand.name]) return false;
        obj[item.product.brand.name] = true;
        return true;
      });
    let finalBrand = [];
    let checkBrand =
      counterBrands.length > 0 &&
      counterBrands.map((item) => {
        finalBrand.push({
          id: item.product.brand.id,
          name: item.product.brand.name,
        });
      });
    // -- need refactor --
    let inStock = [];
    let outOfStock = [];
    let findStock =
      payload.length > 0 &&
      payload.map((item, index) => {
        if (item.latest_price) {
          outOfStock.push(item);
        } else {
          inStock.push(item);
        }
      });
    let finalSort = inStock.concat(outOfStock);
    const newData = _.uniqBy([...state.searchResult, ...finalSort], "id");

    return {
      ...state,
      // searchResult: status_action === 'LOAD_MORE' ? [ ...state.searchResult, ...finalSort ] : finalSort,
      // searchResult: status_action === 'LOAD_MORE' ? newData : finalSort,
      searchKeyword: keyword,
      errorMessageSearch: "Sneaker ditemukan",
      redirectSearch: true,
      isFiltering: false,
      isSearchResultPending: false,
      brandsResult: finalBrand,
      pagination,
      productCategories: { ...state.productCategories, categories: pagination.product_categories },
      caseSorting: sort_by
    }
  } else if (payload.response.status === 404) {
    return {
      ...state,
      searchResult: [],
      searchKeyword: keyword,
      errorMessageSearch: "Not Found",
      redirectSearch: true,
      isSearchResultPending: false,
      isFiltering: false,
      pagination: null,
    };
  } else if (keyword === "") {
    return {
      ...state,
      searchResult: [],
      redirectSearch: true,
      errorMessageSearch: "",
      isFiltering: false,
      isSearchResultPending: false,
      caseSorting: sort_by
    }
  } else {
    return { ...initialState };
  }
};

const handleSortSearchResult = (state, action) => {
  const { res, params, pagination, status_action } = action;
  const newData = _.uniqBy([...state.searchResult, ...res.data.data], "id");

  return {
    ...state,
    searchResult: pagination.current_page === 1 ? res.data.data : newData,
    isSearchResultPending: false,
    isFiltering: false,
    stillPending: false,
    status_code_filter: 0,
    totalFilter: 0,
    message_filter: "",
    caseSorting: params.sort_by,
    pagination,
  };
};

// const handleSortSearchResult = (state, payload) => {
//  console.log('PAYLOAD SORT API ', payload);
//  const { searchResult } = {...state};
//  if (payload === 'MAX_MIN') {
//      let sortMax = searchResult.sort((a, b) => {
//          if (a.latest_price === null) {
//              return 1
//          } else if (b.latest_price === null) {
//              return -1
//          } else {
//              return b.latest_price.asking_price -  a.latest_price.asking_price
//          }
//      })
//      return {
//          ...state, searchResult: sortMax
//      }
//  } else if (payload === 'MIN_MAX') {
//      let sortMin = searchResult.sort((a, b) => {
//          if (a.latest_price === null) {
//              return 1
//          } else if (b.latest_price === null) {
//              return -1
//          } else {
//              return a.latest_price.asking_price -  b.latest_price.asking_price
//          }
//      })
//      return {
//          ...state, searchResult: sortMin
//      }
//  } else if (payload === 'TERBARU') {
//      let sortCreatedAt = searchResult.sort((a, b) => {
//          return new Date(b.created_at) - new Date(a.created_at)
//      })
//      return {
//          ...state, searchResult: sortCreatedAt
//      }
//  } else if (payload === 'KETERSEDIAAN') {
//      let inStock = [];
//      let outOfStock = [];
//      let findStock = searchResult.map((item, index) => {
//          if (item.available_sizes.length === 0) {
//              outOfStock.push(item)
//          } else {
//              inStock.push(item)
//          }
//      })
//      let finalSort = inStock.concat(outOfStock);
//      // console.log('RESULT SORT ', finalSort);
//      return {
//          ...state, searchResult: finalSort
//      }
//  }
// }

const handleFilteringProcess = (state, payload) => {
  const {
    brandId,
    sizeIdMale,
    sizeIdFemale,
    sizeIdKids,
    categorySize,
    maxPrice,
    minPrice,
  } = payload;
  let arrResult = [];
  // let parameterFilter = ['Size', 'Price', 'Brand'];
  let isAbleSize =
    sizeIdMale.length === 0 && sizeIdFemale.length === 0 ? false : true;
  let isAblePrice = maxPrice === null && minPrice === null ? false : true;
  let isAbleBrand = brandId === null ? false : true;

  // @filtering by SIZE
  if (isAbleSize) {
    // --- MALE ---
    if (sizeIdMale.length !== 0) {
      const sizeFiltersMale = state.searchResult.filter((item) => {
        if (item.available_sizes.length !== 0) {
          for (let i = 0; i < sizeIdMale.length; i++) {
            for (let j = 0; j < item.available_sizes.length; j++) {
              if (
                sizeIdMale[i].id === item.available_sizes[j].size_id &&
                item.available_sizes[j].sex === "M"
              ) {
                arrResult.push(item);
              }
            }
          }
        }
      });
    }
    // --- FEMALE ---
    if (sizeIdFemale.length !== 0) {
      const sizeFiltersFemale = state.searchResult.filter((item) => {
        // @base on FEMALE
        if (item.available_sizes.length !== 0) {
          for (let i = 0; i < sizeIdFemale.length; i++) {
            for (let j = 0; j < item.available_sizes.length; j++) {
              if (
                sizeIdFemale[i].id === item.available_sizes[j].size_id &&
                item.available_sizes[j].sex === "F"
              ) {
                arrResult.push(item);
              }
            }
          }
        }
      });
    }
    // --- KIDS ---
    if (sizeIdKids.length !== 0) {
      const sizeFiltersKids = state.searchResult.filter((item) => {
        // @base on KIDS
        if (item.available_sizes.length !== 0) {
          for (let i = 0; i < sizeIdKids.length; i++) {
            item.available_sizes.map((a, index) => {
              if (a.size_id === sizeIdKids[i].id) {
                arrResult.push(item);
              }
            });
          }
        }
      });
    }
    let resultPrice = [];
    let resultBrand = [];
    if (isAblePrice) {
      const priceFilter = arrResult.map((item) => {
        if (item.latest_price !== null) {
          let comparePrice = parseInt(item.latest_price.asking_price);
          let minPrice = parseInt(payload.minPrice);
          let maxPrice = parseInt(payload.maxPrice);
          if (
            comparePrice >= minPrice &&
            (comparePrice <= maxPrice || maxPrice == 0)
          ) {
            resultPrice.push(item);
          }
        }
      });
      arrResult = resultPrice;

      if (isAbleBrand) {
        for (let i = 0; i < resultPrice.length; i++) {
          if (resultPrice[i].product.brand.id === payload.brandId) {
            resultBrand.push(resultPrice[i]);
          }
        }
        arrResult = resultBrand;
      }
    }
  } else if (isAblePrice) {
    // --- PRICE ---
    const priceFilter = state.searchResult.map((item) => {
      if (item.latest_price !== null) {
        let comparePrice = parseInt(item.latest_price.asking_price);
        let minPrice = parseInt(payload.minPrice);
        let maxPrice = parseInt(payload.maxPrice);
        if (
          comparePrice >= minPrice &&
          (comparePrice <= maxPrice || maxPrice == 0)
        ) {
          arrResult.push(item);
        }
      }
      let resultBrand = [];
      if (isAbleBrand) {
        for (let i = 0; i < arrResult.length; i++) {
          if (arrResult[i].product.brand.id === payload.brandId) {
            resultBrand.push(arrResult[i]);
          }
        }
        arrResult = resultBrand;
      }
    });
  } else if (isAbleBrand) {
    // --- BRAND ---
    let hasFilterBrand = [];
    for (let i = 0; i < state.searchResult.length; i++) {
      if (state.searchResult[i].product.brand.id === payload.brandId) {
        hasFilterBrand.push(state.searchResult[i]);
      }
    }
    arrResult = hasFilterBrand;
    // let obj = {};
    // let finalResult = hasFilterBrand.filter((item) => {
    //  if (obj[item.id]) return false;
    //  obj[item.id] = true;
    //  return true;
    // })
  }

  if (arrResult.length === 0) {
    return {
      ...state,
      searchResult: arrResult,
      redirectSearch: false,
      isFiltering: true,
      errorMessageSearch: "Sneaker tidak tersedia!",
      hasExecute: true,
    };
  } else if (
    isAbleSize === false &&
    isAblePrice === false &&
    isAbleBrand === false
  ) {
    // GAK ADA YANG DI PILIH OLEH USER
    // BALIKIN KE POSISI DEFAULT SEARCH RESULT
    return {
      ...state,
      searchResult: state.searchResultTmp,
      // searchResultTmp: [],
      isFiltering: true,
      redirectSearch: false,
      hasExecute: true,
      errorMessageSearch: "Tidak Ada pilihan",
    };
  } else if (
    isAbleSize === false &&
    isAblePrice === true &&
    isAbleBrand === false
  ) {
    return {
      ...state,
      searchResult: arrResult,
      isFiltering: true,
      redirectSearch: false,
      hasExecute: true,
      errorMessageSearch:
        arrResult.length === 0
          ? "Sneaker tidak tersedia!"
          : "Hasil telah ditemukan",
    };
  } else if (
    isAbleSize === true &&
    isAblePrice === false &&
    isAbleBrand === false
  ) {
    return {
      ...state,
      searchResult: arrResult,
      isFiltering: true,
      redirectSearch: false,
      hasExecute: true,
      errorMessageSearch:
        arrResult.length === 0
          ? "Sneaker tidak tersedia!"
          : "Hasil telah ditemukan",
    };
  } else if (
    isAbleSize === true &&
    isAblePrice === true &&
    isAbleBrand === false
  ) {
    return {
      ...state,
      searchResult: arrResult,
      isFiltering: true,
      redirectSearch: false,
      hasExecute: true,
      errorMessageSearch:
        arrResult.length === 0
          ? "Sneaker tidak tersedia!"
          : "Hasil telah ditemukan",
    };
  }
  // SALAH SATU YANG TRUE ANTARA'PRICE' ATAU 'SIZE'
  return {
    ...state,
    searchResult: arrResult,
    isFiltering: true,
    redirectSearch: false,
    hasExecute: true,
    errorMessageSearch:
      arrResult.length === 0
        ? "Sneaker tidak tersedia!"
        : "Hasil telah ditemukan",
  };
};

const clearingBeforeFilter = (state, payload) => {
  if (state.isFiltering === true) {
    return {
      ...state,
      searchResult: state.searchResultTmp,
      errorMessageSearch: "",
      redirectSearch: false,
      hasExecute: false,
    };
  } else {
    return {
      ...state,
      searchResultTmp: state.searchResult,
      hasExecute: false,
    };
  }
};

const filteringHomeScreen = (state, payload) => {
  const { data, status_code, message } = payload;
  return {
    ...state,
    products: {
      ...state.products,
      data,
      status_code,
      message,
      isFetch: false,
      error: null,
      isProductFilter: true,
    },
  };
};

const handleSizeBaseProductId = (state, payload) => {
  const { data, status_code, message } = payload;
  return {
    ...state,
    sizeSingleProduct: {
      ...state.sizeSingleProduct,
      data,
      status_code,
      message,
    },
  };
};

const handleUpdateActiveId = (state, payload) => {
  if (state.activeId !== payload) {
    return { ...state, activeId: payload };
  } else {
    return state;
  }
};

const handleLoadMore = (state, payload) => {
  const {
    data: { data, ...pagination },
  } = payload;
  const newData = _.uniqBy([...state.searchResult, ...data], "id");

  return {
    ...state,
    // searchResult: [...state.searchResult, ...data],
    searchResult: newData,
    isSearchResultPending: false,
    caseSorting: (payload.params && payload.params.sort_by !== null) || payload.params && payload.params.sort_by !== undefined ? payload.params.sort_by : "most_popular",
    pagination
  }
}

const handleFilteringFromApi = (state, payload) => {
  const {
    params: { keyword },
    error,
  } = payload;
  if (error) {
    return Object.assign(keyword ? { searchKeyword: keyword } : {}, {
      ...state,
      searchResult: [],
      isSearchResultPending: false,
      isFiltering: true,
      stillPending: false,
      pagination: null,
      totalFilter: 0,
      message_filter: "Not Found",
      errorMessageSearch: "Not Found",
      status_code_filter: error.response && error.response.status,
    });
  } else {
    const { data, message, status_code } = payload.res;
    const newData = _.uniqBy([...state.searchResultTmp, ...data.data], "id");
    const loadMoreData = _.uniqBy(
      [...state.searchResultTmp, ...data.data],
      "id"
    );

    return Object.assign(keyword ? { searchKeyword: keyword } : {}, {
      ...state,
      searchResult:
        payload.status_action === "LOAD_MORE" ? loadMoreData : newData,
      isFiltering: true,
      isSearchResultPending: false,
      stillPending: false,
      totalFilter: data.total,
      pagination: payload.pagination,
      errorMessageSearch: "Sneaker ditemukan",
      message_filter: message,
      status_code_filter: status_code,
      caseSorting: (payload.params && payload.params.sort_by !== null) || payload.params && payload.params.sort_by !== undefined ? payload.params.sort_by : "most_popular"
    })
  }
};

const minPrice = (prices) => {
  if (!prices) {
    return 0;
  }
  prices = prices.filter((price) => !isNaN(parseInt(price.asking_price)));

  if (Array.isArray(prices)) {
    if (prices.length > 0) {
      let min = null;
      for (let idx in prices) {
        // noinspection JSUnfilteredForInLoop
        let price = prices[idx];
        price.asking_price = parseFloat(price.asking_price);
        if (min == null) {
          min = price.asking_price;
        }
        if (price.asking_price < min) {
          min = price.asking_price;
        }
      }
      return min;
    }
    return 0;
  } else if (typeof prices === "object") {
    return parseFloat(prices.asking_price);
  }

  return 0;
};

const normalizeProduct = (product) => {
  if (!product) {
    return {};
  }

  product.minPrices = {
    availables: minPrice(product.availables),
    pre_orders: minPrice(product.pre_orders),
    pre_owned: minPrice(product.useds)
  };

  return product;
};

const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${PRODUCTS_FETCH}${PROMISE_PENDING}`: {
      return {
        ...state,
        products: { ...state.products, isFetch: true, isProductFilter: false },
      };
    }
    case `${PRODUCTS_FETCH}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = action.payload;
      return {
        ...state,
        products: {
          ...state.products,
          ...data,
          status_code,
          message,
          isFetch: false,
          error: null,
          isProductFilter: false,
        },
      };
    }
    case `${PRODUCTS_FETCH}${PROMISE_REJECTED}`: {
      return {
        ...state,
        products: {
          ...state.products,
          isFetch: false,
          isProductFilter: false,
          ...onError(action.payload),
        },
      };
    }

    case `${PRODUCTS_FETCH_POPULAR}${PROMISE_PENDING}`: {
      return { ...state, products: { ...state.products, isFetch: true, isProductFilter: false } }
    }
    case `${PRODUCTS_FETCH_POPULAR}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = action.payload;
      return {
        ...state,
        products: {
          ...state.products, ...data,
          status_code,
          message,
          isFetch: false,
          error: null,
          isProductFilter: false
        }
      }
    }
    case `${PRODUCTS_FETCH_POPULAR}${PROMISE_REJECTED}`: {
      return {
        ...state,
        products: { ...state.products, isFetch: false, isProductFilter: false, ...onError(action.payload) }
      }
    }

    case `${GET_CONCIERGE}${PROMISE_REJECTED}`: {
      return {
        ...state,
        concierge: {
          ...state.concierge,
          isFetch: false,
          ...onError(action.payload),
        },
      };
    }
    case `${GET_CONCIERGE}${PROMISE_PENDING}`: {
      return { ...state, concierge: { ...state.concierge, isFetch: true } };
    }
    case `${GET_CONCIERGE}${PROMISE_FULFILLED}`: {
      return {
        ...state,
        concierge: {
          ...state.concierge,
          data: action.payload.data.data,
          isFetch: false,
          error: null,
        },
      };
    }
    case `${PRODUCTS_FETCH_RELATED}${PROMISE_PENDING}`: {
      return {
        ...state,
        products: { ...state.products, isFetch: true, isProductFilter: false },
      };
    }
    case `${PRODUCTS_FETCH_RELATED}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = action.payload;
      return {
        ...state,
        products: {
          ...state.products,
          ...data,
          status_code,
          message,
          isFetch: false,
          error: null,
          isProductFilter: false,
        },
      };
    }
    case `${PRODUCTS_FETCH_RELATED}${PROMISE_REJECTED}`: {
      return {
        ...state,
        products: {
          ...state.products,
          isFetch: false,
          isProductFilter: false,
          ...onError(action.payload),
        },
      };
    }

    case `${PRODUCT_DETAIL_FETCH}${PROMISE_PENDING}`: {
      return {
        ...state,
        productDetails: { ...state.productDetails, isFetch: true },
      };
    }
    case `${PRODUCT_DETAIL_FETCH}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = action.payload;
      return {
        ...state,
        productDetails: { ...state.productDetails, ...normalizeProduct(data), status_code, message, isFetch: false, error: null }
      }
    }
    case `${PRODUCT_DETAIL_FETCH}${PROMISE_REJECTED}`: {
      return {
        ...state,
        productDetails: {
          ...state.productDetails,
          isFetch: false,
          ...onError(action.payload),
        },
      };
    }
    case `${PRODUCT_DETAIL_FETCH}${PROMISE_REJECTED}`: {
      return {
        ...state,
        productDetails: {
          ...state.productDetails,
          isFetch: false,
          ...onError(action.payload),
        },
      };
    }
    case SEARCH_STATE: {
      return {
        ...state,
        searchKeyword: action.searchInput,
      };
    }
    case ALL_HANDBAG_CONDITION_PENDING: {
      return {
        ...state,
        handbagCondition: { ...state.handbagCondition, isFetch: true },
      };
    }
    case ALL_HANDBAG_CONDITION_FULFILLED: {
      const { data, status_code, message } = action.payload;
      return {
        ...state,
        handbagCondition: {
          ...state.handbagCondition,
          data: data.data,
          status_code,
          message,
          isFetch: false,
          error: null,
        },
      };
    }
    case ALL_HANDBAG_CONDITION_REJECTED: {
      return {
        ...state,
        handbagCondition: {
          ...state.handbagCondition,
          isFetch: false,
          ...onError(action.payload),
        },
      };
    }
    case CART_ADD: {
      return { ...state, cart: { ...state.cart, ...action.payload } };
    }
    case RECOMMENDED_PRODUCT_FULFILLED: {
      return {
        ...state,
        dataRecommended: {
          data: action.payload.current_page === 1 ?
            action.payload.data :
            state.dataRecommended.data.concat(action.payload.data),
          error: false,
          isFetch: false,
          current_page: action.payload.current_page,
          last_page: action.payload.last_page,
          next_page: action.payload.next_page,
        }
      }
    }
    case RECOMMENDED_PRODUCT_PENDING: {
      return {
        ...state,
        dataRecommended: {
          ...state.dataRecommended,
          error: false,
          isFetch: true
        }
      }
    }
    case RECOMMENDED_PRODUCT_ERROR: {
      return {
        ...state,
        dataRecommended: {
          data: [],
          error: true,
          isFetch: false,
          current_page: 0,
          last_page: 0,
          next_page: 0,
        }
      }
    }
    case MODAL_SEARCH_TOGGLE: {
      return { ...state, modalSearchOpen: action.payload };
    }
    case PRODUCT_SEARCH_PENDING_TOGGLE:
      return { ...state, isSearchResultPending: action.payload }
    case PRODUCT_SEARCH_TO_KA_API:
      return handleSearching(state, action.payload, action.keywordSearch, action.pagination, "", action.caseSorting)
    case 'CLEAR_REDIRECT_SEARCH': {
      return {
        ...state,
        redirectSearch: false,
      };
    }
    case 'PRODUCT_SEARCH_PENDING_TOGGLE_MODAL':
      return { ...state, isSearchResultPending: action.payload }
    case 'PRODUCT_SEARCH_TO_KA_API_MODAL':
      return handleSearchingModal(state, action.payload, action.keywordSearch, action.pagination, "", action.caseSorting)
    case 'CLEAR_REDIRECT_SEARCH_MODAL': {
      return {
        ...state,
        isSearchResultPending: action.payload,
        caseSorting: "",
      };
    }
    case `${BROWSE_ALL_POPULAR_SEARCH}${PROMISE_PENDING}`: {
      return {
        ...state,
        productPopulars: { ...state.productPopulars, isFetch: true },
      };
    }
    case `${BROWSE_ALL_POPULAR_SEARCH}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = action.payload;
      return {
        ...state,
        productPopulars: {
          ...state.productPopulars,
          data,
          status_code,
          message,
          isFetch: false,
          error: null,
        },
      };
    }
    case `${BROWSE_ALL_POPULAR_SEARCH}${PROMISE_REJECTED}`: {
      return {
        ...state,
        productPopulars: {
          ...state.productPopulars,
          isFetch: false,
          ...onError(action.payload),
        },
      };
    }
    case `${SORTING_SEARCH_RESULT_API}${PROMISE_PENDING}`: {
      return {
        ...state,
        searchResultTmp: state.searchResult,
        isSearchResultPending: true,
        isFiltering: false,
        stillPending: true,
        status_code_filter: 0,
        totalFilter: 0,
        message_filter: ''
      }
    }
    case `${SORTING_SEARCH_RESULT_API}${PROMISE_FULFILLED}`:
      return handleSortSearchResult(state, action.payload);
    case FILTERING_SEARCH_RESULT:
      return handleFilteringProcess(state, action.payload);
    case CLEAR_BEFORE_FILTERING:
      return clearingBeforeFilter(state, action.payload);
    case FILTERING_HOMESCREEN:
      return filteringHomeScreen(state, action.payload);
    case GET_SIZE_BASE_PRODUCT_ID:
      return handleSizeBaseProductId(state, action.payload);
    case UPDATE_ACTIVE_PRODUCT:
      return handleUpdateActiveId(state, action.payload);
    case `${BROWSE_ALL_PRODUCT}${PROMISE_PENDING}`: {
      return {
        ...state,
        searchResultTmp: state.searchResult,
        isSearchResultPending: true,
        isFiltering: false,
        stillPending: true,
        status_code_filter: 0,
        totalFilter: 0,
        message_filter: ''
      }
    }
    case `${BROWSE_ALL_PRODUCT}${PROMISE_FULFILLED}`: {
      const payload = action.payload.response.data.data;
      return handleSearching(state, payload, action.keywordSearch, action.pagination, action.status_action, action.caseSorting)
    }
    case `${SEARCH_RESULT_LOAD_MORE}`:
      return handleLoadMore(state, action.payload);
    case "EMPTY_RESULT_FILTERING_FROM_API":
      return {
        ...state,
        searchResult: [],
        errorMessageSearch: "",
      };
    case `${FILTERING_FROM_API}${PROMISE_PENDING}`: {
      return {
        ...state,
        searchResultTmp: state.searchResult,
        isSearchResultPending: true,
        isFiltering: false,
        stillPending: true,
        status_code_filter: 0,
        totalFilter: 0,
        message_filter: ''
      }
    }
    case `${FILTERING_FROM_API}${PROMISE_FULFILLED}`:
      return handleFilteringFromApi(state, action.payload);
    case `${GET_COLLECTION_VARIANTS}${PROMISE_PENDING}`: {
      return {
        ...state,
        searchResult: [],
        errorMessageSearch: "",
        stillPending: true,
      };
    }
    case `${GET_COLLECTION_VARIANTS}${PROMISE_FULFILLED}`: {
      if (action.payload["response"] !== undefined) {
        return {
          ...state,
          searchResult: [],
          errorMessageSearch: 404,
          redirectSearch: true,
          stillPending: false,
        };
      }
      return {
        ...state,
        searchResult: action.payload.data.data,
        errorMessageSearch: action.payload.message,
        redirectSearch: true,
        stillPending: false,
      };
    }
    case `${GET_ADDITIONAL_PRODUCT}${PROMISE_PENDING}`: {
      return {
        ...state,
        searchResult: [...state.searchResult],
        errorMessageSearch: "",
        stillPending: true,
      };
    }
    case `${GET_ADDITIONAL_PRODUCT}${PROMISE_FULFILLED}`: {
      const { current_page, data } = action.payload.data;
      const newData = _.uniqBy(
        [...state.searchResult, ...action.payload.data.data],
        "id"
      );

      if (action.payload["response"] !== undefined) {
        return {
          ...state,
          searchResult: [],
          errorMessageSearch: 404,
          redirectSearch: true,
          stillPending: false,
        };
      }
      return {
        ...state,
        // searchResult: current_page === 1 ? data : [ ...state.searchResult, ...action.payload.data.data ],
        searchResult: current_page === 1 ? data : newData,
        errorMessageSearch: action.payload.message,
        redirectSearch: true,
        stillPending: false,
        pagination: action.payload.data.next_page_url,
      };
    }
    case `${EDITORS_CHOICE_PRODUCT}${PROMISE_PENDING}`: {
      return {
        ...state,
        searchResult: [...state.searchResult],
        errorMessageSearch: "",
        stillPending: true,
      };
    }
    case `${EDITORS_CHOICE_PRODUCT}${PROMISE_FULFILLED}`: {
      const { current_page, data } = action.payload.data;
      const newData = _.uniqBy(
        [...state.searchResult, ...action.payload.data.data],
        "id"
      );

      if (action.payload["response"] !== undefined) {
        return {
          ...state,
          searchResult: [],
          errorMessageSearch: 404,
          redirectSearch: true,
          stillPending: false,
        };
      }
      return {
        ...state,
        // searchResult: current_page === 1 ? data : [ ...state.searchResult, ...action.payload.data.data ],
        searchResult: current_page === 1 ? data : newData,
        errorMessageSearch: action.payload.message,
        redirectSearch: true,
        stillPending: false,
        pagination: action.payload.data.next_page_url,
      };
    }
    case `${UPCOMING_PRODUCT}${PROMISE_PENDING}`: {
      return {
        ...state,
        // searchResult: [ ...state.searchResult ],
        // errorMessageSearch: '',
        // stillPending: true,
        upcomingProduct: {
          ...state.upcomingProduct,
          isFetch: true,
        },
      };
    }
    case `${UPCOMING_PRODUCT}${PROMISE_FULFILLED}`: {
      const { current_page, data } = action.payload.data;
      if (action.payload["response"] !== undefined) {
        return {
          ...state,
          upcomingProduct: {
            ...state.upcomingProduct,
            isFetch: false,
          },
        };
      }
      return {
        ...state,
        upcomingProduct: {
          ...state.upcomingProduct,
          data:
            current_page === 1
              ? data
              : [...state.upcomingProduct.data, ...action.payload.data.data],
          isFetch: false,
          error: null,
          pagination: action.payload.data.next_page_url,
        },
      };
    }
    case `${SEARCH_OPEN}`: {
      return { ...state, isSearchOpen: action.boolean };
    }
    case FETCHING_MOST_SEARCH_RESULTS:
      return onFetchingMostSearchResult(state, action.payload);
    case GET_MOST_SEARCH_RESULTS:
      return onGetMostSearchResults(state, action.payload, action.keyword);
    case MOST_SEARCH_RESULTS_ERROR: {
      return {
        ...state,
        searchKeyword: action.keyword,
        productCategories: {
          ...state.productCategories,
          isFetch: false,
          categories: null,
          ...onError(action.payload),
        },
      };
    }

    case `${USER_RECENT_SEARCH}${PROMISE_PENDING}`: {
      return {
        ...state,
        recentSearch: { ...state.recentSearch, isFetching: true, error: null },
      };
    }
    case `${USER_RECENT_SEARCH}${PROMISE_FULFILLED}`: {
      return {
        ...state,
        recentSearch: {
          ...state.recentSearch,
          data: action.payload.data,
          isFetching: false,
          error: null,
        },
      };
    }
    case `${USER_RECENT_SEARCH}${PROMISE_REJECTED}`: {
      return {
        ...state,
        recentSearch: {
          ...state.recentSearch,
          data: [],
          isFetching: false,
          error: onError(action.payload),
        },
      };
    }

    // FETCH SHOES SALE HISTORY DATA
    case `${FECTH_SHOES_SALE_HISTORY_DATA}${PROMISE_PENDING}`: {
      return {
        ...state,
        saleHistory: { ...state.saleHistory, isFetching: true, error: null },
      };
    }
    case `${FECTH_SHOES_SALE_HISTORY_DATA}${PROMISE_FULFILLED}`: {
      return {
        ...state,
        saleHistory: {
          ...state.saleHistory,
          data: action.payload,
          isFetching: false,
          error: null,
        },
      };
    }
    case `${FECTH_SHOES_SALE_HISTORY_DATA}${PROMISE_REJECTED}`: {
      return {
        ...state,
        saleHistory: {
          ...state.saleHistory,
          data: [],
          isFetching: false,
          error: onError(action.payload),
        },
      };
    }

    case `${GET_COLLECTION_BY_SLUG}${PROMISE_PENDING}`: {
      return {
        ...state,
        collection: {
          ...state.collection,
          isFetching: true,
          error: null,
          status_code: null,
        },
      };
    }
    case `${GET_COLLECTION_BY_SLUG}${PROMISE_FULFILLED}`: {
      const { categories, id, products: { data, current_page, next_page_url }, slug, collection_type, starts_at, expiry, name, description, sort_by } = action.payload.data;
      const { status_code } = action.payload;
      const imagePortrait =
        categories.length > 0 &&
        categories[0].pivot &&
        categories[0].pivot.images.length > 0 &&
        categories[0].pivot.images.find(
          (item) => item.orientation === "portrait"
        );
      const imageLandscape =
        categories.length > 0 &&
        categories[0].pivot &&
        categories[0].pivot.images.length > 0 &&
        categories[0].pivot.images.find(
          (item) => item.orientation === "landscape"
        );
      const newData = _.uniqBy(
        [...state.collection.products.data, ...data],
        "id"
      );

      return {
        ...state,
        collection: {
          ...state.collection,
          isFetching: false,
          error: null,
          id,
          slug,
          collectionType: collection_type,
          imagePortrait: imagePortrait ? imagePortrait.URL : null,
          imageLandscape: imageLandscape ? imageLandscape.URL : null,
          status_code,
          starts_at,
          expiry,
          name,
          description,
          sort_by: sort_by
        },
      };
    }

    case `${GET_ALL_COLLECTION_BY_SLUG}${PROMISE_PENDING}`: {
      return {
        ...state,
        collection: {
          ...state.collection,
          isFetching: true,
          error: null,
          status_code: null,
        },
      };
    }
    case `${GET_ALL_COLLECTION_BY_SLUG}${PROMISE_FULFILLED}`: {
      const { categories, id, products: { data, current_page, next_page_url }, slug, collection_type, starts_at, expiry, name, description } = action.payload.data;
      const { status_code } = action.payload;
      const allCategory = categories.find((n) => n.name === "all_category")

      const imagePortrait =
        allCategory &&
        allCategory.pivot &&
        allCategory.pivot.images.length > 0 &&
        allCategory.pivot.images.find(
          (item) => item.orientation === "portrait"
        );
      const imageLandscape =
        allCategory &&
        allCategory.pivot &&
        allCategory.pivot.images.length > 0 &&
        allCategory.pivot.images.find(
          (item) => item.orientation === "landscape"
        );
      const newData = _.uniqBy(
        [...state.collection.products.data, ...data],
        "id"
      );

      return {
        ...state,
        collection: {
          ...state.collection,
          isFetching: false,
          error: null,
          id,
          slug,
          collectionType: collection_type,
          all_category_banner: {
            imagePortrait: imagePortrait ? imagePortrait.URL : null,
            imageLandscape: imageLandscape ? imageLandscape.URL : null,
          },
          products: {
            data: newData
          },
          status_code,
          starts_at,
          expiry,
          name,
          description
        },
      };
    }
    case `${GET_ALL_COLLECTION_BY_SLUG}${PROMISE_REJECTED}`: {
      return {
        ...state,
        collection: {
          ...state.collection,
          isFetching: false,
          error: null,
          status_code: null,
        },
      };
    }
    case `${GET_ALL_COLLECTION_BY_SLUG}_RESET`: {
      return {
        ...state,
        collection: {
          ...state.collection,
          isFetching: false,
          error: null,
          status_code: null,
        },
      };
    }

    case `${GET_TOP_SELLING_PRODUCT}${PROMISE_PENDING}`: {
      return {
        ...state,
        topSelling: { ...state.topSelling, isFetching: true, error: null },
      };
    }
    case `${GET_TOP_SELLING_PRODUCT}${PROMISE_FULFILLED}`: {
      const { data } = action.payload;
      const { current_page, next_page_url } = data;
      const newData = _.uniqBy([...state.topSelling.data, ...data.data], "id");
      return {
        ...state,
        topSelling: {
          ...state.topSelling,
          data: current_page === 1 ? data.data : newData,
          pagination: data,
          hasMoreData: next_page_url,
          isFetching: false,
          error: null,
        },
      };
    }
    case `${GET_TOP_SELLING_PRODUCT}${PROMISE_REJECTED}`: {
      const { data } = action.payload;

      return {
        ...state,
        topSelling: {
          ...state.topSelling,
          data,
          isFetching: false,
          error: onError(action.payload),
        },
      };
    }

    case `${GET_COLLECTION_BY_SLUG}${PROMISE_PENDING}`: {
      return {
        ...state,
        collection: {
          ...state.collection,
          isFetching: true,
          error: null,
          status_code: null,
        },
      };
    }
    case `${GET_COLLECTION_BY_SLUG}${PROMISE_FULFILLED}`: {
      const {
        categories,
        id,
        products: { data, current_page, next_page_url },
      } = action.payload.data;
      const { status_code } = action.payload;
      const imagePortrait =
        categories.length > 0 &&
        categories[0].pivot &&
        categories[0].pivot.images.length > 0 &&
        categories[0].pivot.images.find(
          (item) => item.orientation === "portrait"
        );
      const imageLandscape =
        categories.length > 0 &&
        categories[0].pivot &&
        categories[0].pivot.images.length > 0 &&
        categories[0].pivot.images.find(
          (item) => item.orientation === "landscape"
        );
      const newData = _.uniqBy(
        [...state.collection.products.data, ...data],
        "id"
      );

      return {
        ...state,
        collection: {
          ...state.collection,
          isFetching: false,
          error: null,
          id,
          imagePortrait: imagePortrait ? imagePortrait.URL : null,
          imageLandscape: imageLandscape ? imageLandscape.URL : null,
          status_code,
        },
      };
    }

    case `${GET_COLLECTION_BY_SLUG}${PROMISE_REJECTED}`: {
      const { status_code } = action.payload;
      return {
        ...state,
        collection: {
          ...state.collection,
          isFetching: false,
          error: onError(action.payload),
          status_code,
        },
      };
    }

    case `${GET_COLLECTION_PRODUCT_LIST}${PROMISE_PENDING}`: {
      return {
        ...state,
        collection: {
          ...state.collection,
          products: {
            ...state.collection.products,
            isFetching: true,
            error: null,
          },
        },
      };
    }
    case `${GET_COLLECTION_PRODUCT_LIST}${PROMISE_FULFILLED}`: {
      const {
        products: { data, current_page, next_page_url },
      } = action.payload.data;
      const { status_code } = action.payload;
      const newData = _.uniqBy(
        [...state.collection.products.data, ...data],
        "id"
      );

      return {
        ...state,
        collection: {
          ...state.collection,
          products: {
            ...state.collection.products,
            isFetching: false,
            data: current_page === 1 ? data : newData,
            hasMoreData: next_page_url,
            status_code,
          },
        },
      };
    }

    case `${GET_COLLECTION_PRODUCT_LIST}${PROMISE_REJECTED}`: {
      const { status_code } = action.payload;

      return {
        ...state,
        collection: {
          ...state.collection,
          products: {
            ...state.collection.products,
            isFetching: false,
            error: onError(action.payload),
            status_code,
          },
        },
      };
    }

    case `${FETCH_COLLECTION_PRODUCT_LIST}${PROMISE_PENDING}`: {
      return {
        ...state,
        collection: {
          ...state.collection,
          products: {
            ...state.collection.products,
            isFetching: true,
            error: null
          }
        }
      }
    }

    case `${FETCH_COLLECTION_PRODUCT_LIST}${PROMISE_FULFILLED}`: {
      const { data, current_page, next_page_url } = action.payload.data;
      const { status_code } = action.payload;
      const newData = _.uniqBy(
        [...state.collection.products.data, ...data],
        "id"
      );

      return {
        ...state,
        collection: {
          ...state.collection,
          products: {
            ...state.collection.products,
            isFetching: false,
            data: current_page === 1 ? data : newData,
            hasMoreData: next_page_url,
            status_code,
          },
        },
      };
    }

    case `${FETCH_COLLECTION_PRODUCT_LIST}${PROMISE_REJECTED}`: {
      const { status_code } = action.payload;

      return {
        ...state,
        collection: {
          ...state.collection,
          products: {
            ...state.collection.products,
            isFetching: false,
            error: onError(action.payload),
            status_code,
            data: JSON.stringify(action.payload.message).includes("status code 404") ? [] : [...state.collection?.products?.data]
          },
        },
      };
    }

    case `${SECTION_DETAILS}${PROMISE_PENDING}`: {
      return {
        ...state,
        dataSection: {
          ...state.dataSection,
          error: null,
        },
      };
    }
    case `${SECTION_DETAILS}${PROMISE_FULFILLED}`: {
      const { data } = action.payload;

      return {
        ...state,
        dataSection: {
          ...state.dataSection,
          data,
          error: null,
        },
      };
    }
    case `${SECTION_DETAILS}${PROMISE_REJECTED}`: {
      const { data } = action.payload;

      return {
        ...state,
        dataSection: {
          ...state.dataSection,
          data,
          error: onError(action.payload),
        },
      };
    }

    case `${CLICK_MENU_NAVBAR}`: {
      return {
        ...state,
        isClickMenu: action.payload
      }
    }

    case "SAVE_COLLECTION_SORT": {
      return {
        ...state,
        caseSorting: action.data
      }
    }

    default: return state
  }
};

export default productReducer;